import { GraphicDataRequest } from 'screens/NewDashboard/@types/graphic';

import theme from 'styles/theme';
import { Oval } from 'react-loader-spinner';
import { useTranslation } from 'react-i18next';
import { Options } from '../Options';
import { ChartComponent } from './components/ChartComponent';

import { GraphContainer, LoadingContainer } from './styles';
import { FunnelChartComponent } from './components/FunnelChartComponent';

export interface GraphProps {
  data: GraphicDataRequest;
  loading?: boolean;
  indicatorColor: string;
  size?: 'small' | 'medium' | 'large';
  hasOptions?: boolean;
}

export function Graph({ data, loading, indicatorColor, size, hasOptions = false }: GraphProps) {
  const { t: translation, i18n } = useTranslation();
  if (data.type.type === 'PieChart') {
    if (window.innerWidth >= 1000) {
      data.options.chartArea = { width: '80%' };
    } else {
      data.options.chartArea = { width: '100%' };
    }
  }

  const handleFunnelChartData = (data: (string | number)[][]) => {
    const newData = data.map((item) => {
      const [name, ...values] = item;
      return {
        name: name as string,
        values: values as number[],
      };
    });

    newData.sort((a, b) => {
      if (a.values[0] < b.values[0]) {
        return 1;
      }
      if (a.values[0] > b.values[0]) {
        return -1;
      }
      return 0;
    });
    return newData;
  };

  return (
    <GraphContainer color={indicatorColor} size={size}>
      {!loading ? (
        <>
          <header>
            <div className="title">
              <strong>{data.title}</strong>
            </div>
            {hasOptions && <Options data={data} type="graphic" color="#4c4e61" />}
          </header>
          {data.data.length > 1 ? (
            <>
              {data.type.type === 'ComboChart' || data.type.type === 'PieChart' || data.type.type === 'BarChart' ? (
                <>
                  <ChartComponent
                    chartType={data.type.type}
                    data={data.data}
                    options={data.options}
                    diffdata={data.diffdata}
                    size={size}
                    hAxisTitle={data.hAxisTitle}
                  />
                </>
              ) : (
                <FunnelChartComponent data={handleFunnelChartData(data.data)} />
              )}
            </>
          ) : (
            <div className="noContent">
              <p>Não há dados disponíveis para este gráfico</p>
            </div>
          )}
          <footer>
            {data.sourceurl ? (
              <p>
                {translation('dashboardPage.graphics.source')}:{' '}
                <a className='notranslate' href={data.sourceurl} target="_blank" rel="noopener noreferrer">
                  {' '}
                  {data.source}{' '}
                </a>
              </p>
            ) : (
              <p>
                {/* eslint-disable-next-line */}
                {translation('dashboardPage.graphics.source')}: {translation('dashboardPage.graphics.compilation')}{' '}
              </p>
            )}
            {data.consultDate ? (
              <p>
                <br />
                {translation('dashboardPage.graphics.date')}:{' '}
                {new Date(`${data.consultDate}T12:00:00`).toLocaleDateString(i18n.language, {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })}
              </p>
            ) : (
              <br />
            )}
          </footer>
        </>
      ) : (
        <LoadingContainer>
          <Oval height={80} width={80} strokeWidth={4} color={theme.colors.blue600} secondaryColor={theme.colors.blue500} />
        </LoadingContainer>
      )}
    </GraphContainer>
  );
}
